import React, { useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'
import { toast } from 'react-toastify'
import { CREATE, useClient } from '@peracto/client'
import { Heading } from '@peracto/peracto-ui'

import RuleForm from './RuleForm'
import { ruleForApi, ruleSchema } from './ruleTypes'
import { showApiError } from './apiErrors'

const RuleAdd = () => {
    const { client } = useClient()
    const [redirect, setRedirect] = useState('')

    const onSubmit = async (values, actions) => {
        try {
            const response = await client(CREATE, 'tecdoc-brand-rules', { data: ruleForApi(values) })
            toast.success('Brand rule added.')
            actions.setSubmitting(false)
            setRedirect(response.data['@id'])
        } catch (e) {
            showApiError(e, actions)
        }
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    return (
        <>
            <Helmet>
                <title>TecDoc Brand Rules | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Brand Rule">
                    <div className="flex-grow-1 d-flex align-items-center justify-content-end">
                        <Link className="btn btn-outline-primary" to="/tecdoc-brand-rules">
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="mr-2" />
                            Back to Brand Rules
                        </Link>
                    </div>
                </Heading>
                <RuleForm onSubmit={onSubmit} schema={ruleSchema} />
            </div>
        </>
    )
}

export default RuleAdd
